"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _hwTransport = require("@ledgerhq/hw-transport");

var _hwTransport2 = _interopRequireDefault(_hwTransport);

var _errors = require("@ledgerhq/errors");

var _scrambling = require("@ledgerhq/devices/lib/scrambling");

var _logs = require("@ledgerhq/logs");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var attemptExchange = function attemptExchange(apdu, timeout, scrambleKey) {
  if (!scrambleKey) {
    throw new _errors.TransportError("transport.setScrambleKey must be used to set a scramble key. Refer to documentation.", "NoScrambleKey");
  }

  if (!navigator.credentials) {
    throw new _errors.TransportError("WebAuthn not supported", "NotSupported");
  }

  return navigator.credentials
  // $FlowFixMe
  .get({
    publicKey: {
      timeout: timeout,
      challenge: new Uint8Array(32),
      allowCredentials: [{
        type: "public-key",
        id: new Uint8Array((0, _scrambling.wrapApdu)(apdu, scrambleKey))
      }]
    }
  })
  // $FlowFixMe
  .then(function (r) {
    return Buffer.from(r.response.signature);
  });
};

/**
 * WebAuthn Transport implementation
 * @example
 * import TransportWebAuthn from "@ledgerhq/hw-transport-webauthn";
 * ...
 * TransportWebAuthn.create().then(transport => ...)
 */

var TransportWebAuthn = function (_Transport) {
  _inherits(TransportWebAuthn, _Transport);

  function TransportWebAuthn() {
    _classCallCheck(this, TransportWebAuthn);

    return _possibleConstructorReturn(this, (TransportWebAuthn.__proto__ || Object.getPrototypeOf(TransportWebAuthn)).apply(this, arguments));
  }

  _createClass(TransportWebAuthn, [{
    key: "exchange",


    /**
     * Exchange with the device using APDU protocol.
     * @param apdu
     * @returns a promise of apdu response
     */
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(apdu) {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                (0, _logs.log)("apdu", "=> " + apdu.toString("hex"));
                _context.next = 3;
                return attemptExchange(apdu, this.exchangeTimeout, this.scrambleKey);

              case 3:
                res = _context.sent;

                (0, _logs.log)("apdu", "<= " + res.toString("hex"));
                return _context.abrupt("return", res);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function exchange(_x) {
        return _ref.apply(this, arguments);
      }

      return exchange;
    }()

    /**
     * A scramble key is a string that xor the data exchanged.
     * It depends on the device app you need to exchange with.
     * For instance it can be "BTC" for the bitcoin app, "B0L0S" for the dashboard.
     *
     * @example
     * transport.setScrambleKey("B0L0S")
     */

  }, {
    key: "setScrambleKey",
    value: function setScrambleKey(scrambleKey) {
      this.scrambleKey = Buffer.from(scrambleKey, "ascii");
    }
  }, {
    key: "close",
    value: function close() {
      return Promise.resolve();
    }
  }], [{
    key: "open",


    /*
     */
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", new TransportWebAuthn());

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function open() {
        return _ref2.apply(this, arguments);
      }

      return open;
    }()

    /*
     */

  }]);

  return TransportWebAuthn;
}(_hwTransport2.default);

TransportWebAuthn.isSupported = function () {
  return Promise.resolve(!!navigator.credentials);
};

TransportWebAuthn.list = function () {
  return navigator.credentials ? [null] : [];
};

TransportWebAuthn.listen = function (observer) {
  if (!navigator.credentials) {
    observer.error(new _errors.TransportError("WebAuthn not supported", "NotSupported"));
    return { unsubscribe: function unsubscribe() {} };
  }
  observer.next({ type: "add", descriptor: null });
  observer.complete();
  return { unsubscribe: function unsubscribe() {} };
};

exports.default = TransportWebAuthn;
//# sourceMappingURL=TransportWebAuthn.js.map